import { fetchApi } from '../../../lib/fetchApi';
import { SendEmailDto } from '../../admin/generic/types';
import { UserRestorePwdDto } from '../types';

export const updateLanguageAPI = async (language: string): Promise<void> => {
    await fetchApi.get(`/auth/language/${language}`);
};

export const restoreUser = async (body: UserRestorePwdDto): Promise<void> => {
     await fetchApi.post(`/auth/restore/${body.uid}/${body.language}`,  body );
};

export const sendEmailUserRestorePwd = async (body: SendEmailDto): Promise<void> => {
    await fetchApi.post(`/auth/sendEmail`, body);
};